import {
  NameLabelColor,
  ALL_NAME_LABEL_COLORS,
  NAME_LABEL_COLOR_TO_FILL_COLOR,
} from '../../vendor/react-native-tapnovel-viewer';

export default NameLabelColor;

export {ALL_NAME_LABEL_COLORS, NAME_LABEL_COLOR_TO_FILL_COLOR};
